// extracted by mini-css-extract-plugin
export var careServiceTypeContainer = "styles-module--careServiceTypeContainer--3b1_M";
export var careServiceTypeListContainer = "styles-module--careServiceTypeListContainer--1pBkl";
export var icon = "styles-module--icon--1FuoF";